/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_View_Camera_GpsInputs */

const vi_order_view_camera_gps = /** @type {(inputs: Order_View_Camera_GpsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem camera/GPS`)
};

/**

* @param {Order_View_Camera_GpsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_view_camera_gps = /** @type {((inputs?: Order_View_Camera_GpsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_View_Camera_GpsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_view_camera_gps(inputs)
});